import { useTranslation } from "react-i18next";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { MaterialChangeDisclaimerModal } from "#modules/quoteRequestLines/MaterialChangeDisclaimerModal";
import { useMaterialSelect } from "#modules/quoteRequestLinesV2/hooks/useMaterialSelect";
import { SelectInputController } from "#shared/view/designSystem/inputs/SelectInputController";
import { AssemblyWithChildren, MaterialGradeType } from "shared";

import { INPUT_MIN_WIDTH } from "./views/PredictionData/constants";

type Props = {
  onChange: (materialName: string, materialGrade: MaterialGradeType | null) => void;
  disabled?: boolean;
  withEmptyData?: boolean;
  size?: "sm" | "md";
  maw?: number;
  miw?: number;
  withLabel?: boolean;
  assembly?: AssemblyWithChildren<QuoteRequestLineDto>;
  quoteRequestLine?: QuoteRequestLineDto;
};

export const MaterialSelect = ({
  onChange,
  disabled,
  size = "md",
  maw,
  miw,
  withLabel = true,
  assembly,
  quoteRequestLine,
}: Props) => {
  const { t } = useTranslation();
  const {
    displayValue,
    materialOptions,
    onSelectChange,
    modalOpened,
    onModalClose,
    onModalConfirm,
    checkboxProps,
  } = useMaterialSelect({ onChange, assembly, quoteRequestLine });

  return (
    <>
      <SelectInputController
        disabled={disabled}
        label={withLabel ? t("qrl.materialSpecification") : ""}
        placeholder={!withLabel ? t("qrl.materialSpecification") : ""}
        name="materialName"
        value={displayValue}
        onChange={onSelectChange}
        data={materialOptions}
        size={size}
        maw={maw}
        miw={miw || INPUT_MIN_WIDTH}
        searchable
        allowDeselect={false}
        withEmptyData={false}
      />

      <MaterialChangeDisclaimerModal
        opened={modalOpened}
        onClose={onModalClose}
        onConfirm={onModalConfirm}
        checkboxProps={checkboxProps}
      />
    </>
  );
};
